import { render, staticRenderFns } from "./edit-company-comment.vue?vue&type=template&id=7f11da95&"
import script from "./edit-company-comment.vue?vue&type=script&lang=js&"
export * from "./edit-company-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports